import { Heading, Box, Gap, Input, CopyToClipboard } from '@salecycle/ui-component-library';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const getFolderLocationInfo = (clientId, folder) => {
  const env = import.meta.env.VITE_ENV === 'production' ? 'prod' : 'poc';
  const awsRegion = 'eu-west-1';
  const s3BucketName = `public-sftp-preprocessed-${env}`;
  const s3FolderPath = `${clientId}/from-salecycle/${folder}`;
  const ssrsFilepath = `\\\\ad.salecycle.com\\ssrs\\SSRSExports\\${clientId}\\from-salecycle\\${folder}`;
  const ssrsFilepathFormatted = ssrsFilepath.split('/').join('\\');
  const clipboardValue = `S3 Bucket:     ${s3BucketName}\nS3 Path:       ${s3FolderPath}\nAWS Region:    ${awsRegion}\nSSRS Location: ${ssrsFilepathFormatted}`;
  return { clipboardValue };
};

export interface IProps {
  clientId: string;
  s3SubFolder: string;
  onChangeFolder: (name: string) => void;
  isDisabled: boolean;
}

export const FileExportFolderWithCopy = ({
  clientId,
  s3SubFolder,
  onChangeFolder = (value: string) => {
    return;
  },
  isDisabled,
}: IProps) => {
  const { t } = useTranslation('fileExport');

  const { clipboardValue } = useMemo(() => getFolderLocationInfo(clientId, s3SubFolder), [clientId, s3SubFolder]);

  if (!clientId) {
    return null;
  }

  return (
    <>
      <Gap top={20} />
      <Heading variation="h3">{t('config.create.folder.heading')}</Heading>
      <Box>
        <Input
          inputTestId="folder-name-test"
          label={t('config.create.folder.name.label')}
          ariaLabel={t('config.create.folder.name.label')}
          inputId="folder-name"
          value={s3SubFolder}
          onChange={onChangeFolder}
          placeholder={t('config.create.folder.name.placeholder')}
          tooltipHeading={t('config.create.folder.tooltip')}
          disabled={isDisabled}
        />
        <Gap right={20} />
        <Box stackItems={true}>
          <CopyToClipboard value={clipboardValue} showIconOnly={true} disabled={!s3SubFolder} topGap={50} />
        </Box>
      </Box>
    </>
  );
};
